// extracted by mini-css-extract-plugin
export default {"cls1":"ZogLBoiBMpZvqmrG_rUD","cls2":"XJJQvnuozDF6WCKAHylg ZogLBoiBMpZvqmrG_rUD"};